import React from "react";

export default function PendingText() {
	return <span className='pending'>*pending*</span>;
}